import { render, staticRenderFns } from "./PpeRegisters.vue?vue&type=template&id=1c627d84&"
import script from "./PpeRegisters.vue?vue&type=script&lang=js&"
export * from "./PpeRegisters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports